import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SettingsProvider } from "@/context/SettingsContext";
import { AdminProvider } from "@/admin/AdminContext";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import Order from "@/pages/Order";
import Track from "@/pages/Track";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Dashboard from "@/admin/pages/Dashboard";
import Orders from "@/admin/pages/Orders";
import Services from "@/admin/pages/Services";
import Pricing from "@/admin/pages/Pricing";
import Coupons from "@/admin/pages/Coupons";
import Customers from "@/admin/pages/Customers";
import ReviewsAdmin from "@/admin/pages/ReviewsAdmin";
import BlogAdmin from "@/admin/pages/BlogAdmin";
import Integrations from "@/admin/pages/Integrations";
import Settings from "@/admin/pages/Settings";
import Logs from "@/admin/pages/Logs";

const LEGAL_SLUGS = ["gizlilik-politikasi", "kullanim-kosullari", "iade-ve-iptal", "kvkk", "iletisim"];

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" theme="dark" richColors />
      <SettingsProvider>
        <AdminProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/siparis-ver" element={<Order />} />
              <Route path="/siparis-takip" element={<Track />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              {LEGAL_SLUGS.map((slug) => <Route key={slug} path={`/${slug}`} element={<Legal />} />)}

              <Route path="/adc" element={<AdminLogin />} />
              <Route path="/adc" element={<AdminLayout />}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="orders" element={<Orders />} />
                <Route path="services" element={<Services />} />
                <Route path="pricing" element={<Pricing />} />
                <Route path="coupons" element={<Coupons />} />
                <Route path="customers" element={<Customers />} />
                <Route path="reviews" element={<ReviewsAdmin />} />
                <Route path="blog" element={<BlogAdmin />} />
                <Route path="integrations" element={<Integrations />} />
                <Route path="settings" element={<Settings />} />
                <Route path="logs" element={<Logs />} />
              </Route>

              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </AdminProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
